export default function useMethods(gallery: Model.Response<Interfaces.Photo[]>): Customer.Models.Gallery.Methods {
    const store = getStorePhotoMethod(gallery)
    const destroy = getDestroyPhotoMethod(gallery)
    const update = getUpdatePhotoMethod(gallery)

    return {
        store,
        destroy,
        update
    }
}


function getUpdatePhotoMethod(gallery: Model.Response<Interfaces.Photo[]>) {
    return (photo: Interfaces.Photo) => {
        gallery.setData(old => {
            if (!old) return

            return old.map(item => {
                if (item.id === photo.id)
                    return photo
                
                return item
            })
        })
    }
}

function getDestroyPhotoMethod(gallery: Model.Response<Interfaces.Photo[]>) {
    return (photoId: number) => {
        gallery.setData(old => {
            if (!old) return

            return old.filter(photo => photo.id !== photoId)
        })
    }
}

function getStorePhotoMethod(gallery: Model.Response<Interfaces.Photo[]>) {
    return (photo: Interfaces.Photo) => {
        gallery.setData(old => {
            if (!old) return

            if (old.find(item => item.id === photo.id))
                return old

            return [...old, photo]
        })
    }
}